<template>
  <div>
    <LoadingWidget v-if="loading" class="py-16" />

    <transition name="fade">
      <v-sheet
        v-if="!loading"
        class="
          d-flex
          align-center
          py-10 py-md-12 py-lg-16
          position-relative
          item
        "
        width="100%"
        min-height="650px"
        color="primary"
      >
        <img
          v-if="
            item.img &&
            item.img.featured &&
            item.img.featured.path &&
            mdAndUp &&
            !video
          "
          :src="files + item.img.featured.path + '?resize=1&w=950'"
          :alt="item.title"
          class="d-block item-img"
        />
        <video
          v-if="video && mdAndUp"
          class="item-video"
          autoplay
          loop
          muted
          controls
          :src="video"
        ></video>
        <v-container>
          <v-row
            :justify="
              item.img && item.img.featured && item.img.featured.path && mdAndUp
                ? 'start'
                : 'center'
            "
          >
            <v-col cols="12" md="6" lg="5" class="pr-md-12 pr-lg-3">
              <TitleWidget
                :title="item.title"
                :subtitle="item.subtitle"
                class="
                  justify-center justify-md-start
                  text-center text-md-left
                  white--text
                "
              />

              <img
                v-if="
                  item.img &&
                  item.img.featured &&
                  item.img.featured.path &&
                  !mdAndUp &&
                  !video
                "
                :src="files + item.img.featured.path + '?resize=1&w=600'"
                :alt="item.title"
                class="d-block mx-n3 mt-6 item-img"
              />
              <video
                v-if="video && !mdAndUp"
                autoplay
                class="item-video-mobile mt-6"
                loop
                muted
                controls
                :src="video"
              ></video>

              <div
                class="
                  text-body-2 text-md-subtitle-2
                  white--text
                  font-weight-regular
                  mt-6
                  item-text
                "
                v-html="item.introduction"
              ></div>

              <ButtonWidget
                class="justify-center justify-md-start mt-6 mt-sm-8 mt-md-12"
                secondary
                :to="path"
              >
                SAIBA MAIS
              </ButtonWidget>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
  path: "/quem-somos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    video() {
      return this.item.video
        ? this.files + this.item.video.featured.path
        : null;
    },
    mdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-video {
    position: absolute;
    right: 0;
    width: 50%;
    object-fit: contain;
    &-mobile {
      width: 100%;
    }
  }
  &-img {
    width: 100vw;
    @media screen and (min-width: 960px) {
      height: 100%;
      object-fit: cover;
      -o-object-fit: cover;
      position: absolute;
      right: 0;
      top: 0;
      width: 50%;
    }
  }

  &-text {
    display: -webkit-box;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 30px !important;
  }
}
</style>
